<!-- @format -->

@if (courseUnitVersions.length > 0) {
  <div>
    <span translate="STUDIES.COURSE_UNIT_INFO_MODAL.VERSION"></span>:
    <sis-dropdown-select
      [compact]="true"
      [options]="options"
      [selection]="currentCourseUnit.id"
      (selectionChange)="selectVersion($event)"></sis-dropdown-select>
  </div>
}
